import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, Tag, ArrowRight, X } from "lucide-react";

export function CouponDialog({ open, onClose, onCheckout, price, loading }) {
  const [code, setCode] = useState("");

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm" data-testid="coupon-dialog-overlay">
      <div className="bg-white rounded-2xl w-full max-w-sm mx-4 p-6 relative" style={{ boxShadow: "0 25px 50px rgba(0,0,0,0.25)" }} data-testid="coupon-dialog">
        <button onClick={onClose} className="absolute top-4 right-4 text-[#9CA3AF] hover:text-[#111827]" data-testid="coupon-dialog-close">
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-5">
          <div className="w-10 h-10 bg-[#EEF2FF] rounded-full flex items-center justify-center mx-auto mb-3">
            <Tag className="w-5 h-5 text-[#3B5BDB]" />
          </div>
          <h3 className="text-lg font-heading font-bold text-[#111827]">Complete Your Purchase</h3>
          <p className="text-sm text-[#6B7280] mt-1">Get your personalized fix plan for <span className="font-semibold text-[#111827]">${price}</span></p>
        </div>

        <div className="mb-5">
          <label className="text-xs font-medium text-[#6B7280] mb-1.5 block">Have a coupon code?</label>
          <div className="flex gap-2">
            <Input
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="Enter code"
              className="flex-1 bg-white border-[#E5E7EB] text-[#111827] placeholder:text-[#9CA3AF] uppercase tracking-wider"
              data-testid="coupon-code-input"
            />
          </div>
        </div>

        <Button
          onClick={() => onCheckout(code.trim() || null)}
          disabled={loading}
          className="w-full bg-[#3B5BDB] hover:bg-[#2F4AC7] text-white font-semibold h-11"
          data-testid="coupon-checkout-btn"
        >
          {loading ? (
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          ) : (
            <ArrowRight className="w-4 h-4 mr-2" />
          )}
          {code.trim() ? "Apply & Checkout" : `Pay $${price}`}
        </Button>

        <p className="text-[10px] text-center text-[#9CA3AF] mt-3">One-time payment, not a subscription</p>
      </div>
    </div>
  );
}
